import "@splidejs/react-splide/css";

import { AspectRatio, Box, Flex, HStack } from "@chakra-ui/react";
import React, { useMemo, useState } from "react";

import styled from "styled-components";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { MdArrowBackIos, MdArrowForwardIos } from "../../customIcons";

const Carousel = ({ images }: any) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const handleThumbs = (index: number) => {
    setActiveImageIndex(index);
  };

  const handlePrev = () => {
    const numberOfImages = images.length;
    const newActiveImageIndex =
      activeImageIndex - 1 < 0 ? numberOfImages - 1 : activeImageIndex - 1;
    setActiveImageIndex(newActiveImageIndex);
  };

  const activeImage = useMemo(() => {
    if (images) {
      return images[activeImageIndex];
    }

    return {};
  }, [images, activeImageIndex]);

  const handleNext = () => {
    const numberOfImages = images.length;

    setActiveImageIndex((activeImageIndex + 1) % numberOfImages);
  };

  const activeImageData =
    activeImage?.localFile?.childrenImageSharp?.[0] || activeImage?.sourceUrl;
  const activeGatsbyImage = activeImageData
    ? getImage(activeImageData) || activeImageData
    : null;

  const Div = styled.div`
    .arrow-container {
      position: relative;
      li {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .splide__arrow--prev svg,
    .splide__arrow--next svg {
      rotate: 90deg;
    }
  `;

  return (
    <>
      <Div>
        <Flex flexFlow="column-reverse" justifyContent="center" gap={0}>
          {images?.length > 0 && (
            <HStack
              w="100%"
              mx="auto"
              mt="60px"
              flexDir="row"
              alignItems="center"
              justifyContent={{ base: "space-between", md: "center" }}
              pos={"relative"}
              bg="#fff"
              top={0}
              transform="translateY(-50%)"
              zIndex={2}
            >
              <Box onClick={handlePrev} userSelect="none" cursor={"pointer"}>
                <MdArrowBackIos />
              </Box>

              {images.slice(0, 3).map((image: any, index: any) => {
                const imageData =
                  image.localFile?.childrenImageSharp?.[0] || image.sourceUrl;
                const gatsbyImage = imageData
                  ? getImage(imageData) || imageData
                  : null;

                return (
                  <Box
                    w={"92px"}
                    h={"92px"}
                    minH={"64px"}
                    mx={5}
                    key={index}
                    onClick={() => handleThumbs(index)}
                    style={{
                      display: "block",
                      border:
                        activeImageIndex === index
                          ? "1px solid #DBA4B9"
                          : "none",
                    }}
                  >
                    {gatsbyImage && typeof gatsbyImage !== "string" ? (
                      <GatsbyImage
                        image={gatsbyImage}
                        alt="Thumbnail Image"
                        objectFit="cover"
                        style={{ height: "90px", width: "90px" }}
                      />
                    ) : image.sourceUrl ? (
                      <img
                        src={image.sourceUrl}
                        alt="Thumbnail Image"
                        style={{
                          height: "90px",
                          width: "90px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <StaticImage
                        rel="preload"
                        src="../../../images/productplaceholder.png"
                        alt="Thumbnail placeholder"
                        objectFit="cover"
                        layout="fullWidth"
                        style={{
                          height: "100%",
                          width: "100%",
                          backgroundColor: "transparent !important",
                        }}
                      />
                    )}
                  </Box>
                );
              })}

              <Box onClick={handleNext} userSelect="none" cursor="pointer">
                <MdArrowForwardIos />
              </Box>
            </HStack>
          )}
          <Box alignItems="center" mx="center" maxW={"720px"}>
            <AspectRatio
              mx="auto"
              ratio={1 / 1}
              h={{ base: "auto", sm: "484px", md: "584px" }}
              w={{ base: "320px", sm: "484px", md: "584px" }}
            >
              {activeGatsbyImage && typeof activeGatsbyImage !== "string" ? (
                <GatsbyImage
                  image={activeGatsbyImage}
                  alt="Product Image"
                  objectFit="cover"
                  style={{ height: "100%", width: "100%" }}
                />
              ) : activeImage?.sourceUrl ? (
                <img
                  src={activeImage.sourceUrl}
                  alt="Product Image"
                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                />
              ) : (
                <StaticImage
                  rel="preload"
                  src="../../../images/productplaceholder.png"
                  alt="Product placeholder"
                  objectFit="cover"
                  layout="fullWidth"
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "transparent !important",
                  }}
                />
              )}
            </AspectRatio>
          </Box>
        </Flex>
      </Div>
    </>
  );
};

export default Carousel;
